
    <div class="loader">
      <mat-spinner [diameter]="40" [strokeWidth]="4"></mat-spinner>
    </div>
  